import { cn } from "@repo/ui/lib/utils";
import { Outlet, useRouterState } from "@tanstack/react-router";

import { Content } from "~/components/app/content";

export const SettingsLayout = () => {
  // The Plans page shows three rich pricing columns, so it needs a wider column
  // than the default settings pages (which stay comfortable at max-w-2xl).
  const isPlans = useRouterState({
    select: (s) => s.location.pathname.startsWith("/settings/plans"),
  });

  return (
    <Content.Body>
      <div className="flex shrink grow justify-center">
        <div
          className={cn(
            "my-12 flex w-full flex-col gap-6",
            isPlans ? "sm:max-w-5xl" : "sm:max-w-2xl",
          )}
        >
          <Outlet />
        </div>
      </div>
    </Content.Body>
  );
};
